import AppDispatcher from '../core/AppDispatcher.jsx';
import Constants from '../constants/AccountSettingsConstants.js';
import ApplicationConstants from '../constants/ApplicationConstants.js';
import AccountTypeConstants from '../constants/AccountTypeConstants';
import Mapper from '../utils/Mapper.js';
import Formatter from '../utils/Formatter.js';
import Products from '../utils/Products.js';
import Validators from '../utils/Validators';
import _ from 'lodash';
import { EventEmitter } from 'events';
import YourDetailsConstants from '../constants/YourDetailsConstants.js';

const CHANGE_EVENT = 'change';
const ActionTypes = Constants.ActionTypes;
const ApplicationActionTypes = ApplicationConstants.ActionTypes;
const AccountTypeActionsTypes = AccountTypeConstants.ActionTypes;
const YourDetailsActionTypes = YourDetailsConstants.ActionTypes;
const AccountTypeCodes = ApplicationConstants.AccountTypeCodes;
const _customAttributeName = _.clone(Constants.customAttributeName);
const _rules = _.clone(Constants.accountSettingsRule);

let _summaryError, _formError, _model, _accountType, _productId, _titleList = {};

function storeInit(){
    _model = [];
    _summaryError = [];
    _formError = [];
    _accountType = undefined;
}

function defaultInvestor() {
    if (Products.isAnnuity(_productId)){
        switch (_accountType) {
            case AccountTypeCodes.JOINT:
                addInvestors(2);
                break;
            default:
                addInvestors(1);
                break;
        }
    }
}

function addInvestors(num){
    _.times(num, () => {
        _model.push(_.cloneDeep(Constants.accountSettingsModel));
    });
}

function setAccountType(accountType) {
    storeInit();
    _accountType = accountType;
    defaultInvestor();
}

function setProductId(productId){
    storeInit();
    _productId = productId;
}

function updateAccountSettingsModel(fieldId, value, index) {
    _model[index][fieldId] = Mapper.toTrim(value);
}

function updateYourDetailsData(fieldId, value, index = 0) {
    if (_model.length > 1 && _model[index].name.hasOwnProperty(fieldId)){
        let name = _model[index].name;
        name[fieldId] = Mapper.toTrim(value);
        let title = Mapper.getGenderTitle(name.gender, name.title, _titleList, YourDetailsConstants.Values.GENDER_MALE, YourDetailsConstants.Values.GENDER_FEMALE);
        name.fullName = Formatter.formatFullname(title, name.givenName, name.lastName);
    }
}

function getValidationRules(fieldId){
    if (!fieldId) {
        return _rules;
    }

    if (!_rules[fieldId]) {
        return null;
    }

    var rulesForField = {};
    rulesForField[fieldId] = _rules[fieldId];
    return rulesForField; 
}

function validate(fieldId, componentId, value){
    let rules = getValidationRules(fieldId);

    let data = {};
    data[fieldId] = value;
    Validators.validateField(data, rules, _customAttributeName, _formError, fieldId, componentId);
}

function validateAll() {
    let rules = getValidationRules();

    var multipleSectionId = Products.getInvestorTypeMessageId(_accountType);
    _summaryError = [];
    _formError = [];
    _.times(_model.length, function(index){
        let id = 'as{x}' + index;
        _summaryError = _summaryError.concat(Validators.validateAll(_model[index], rules, _customAttributeName, id , 'Account settings', (_model.length > 1) ? multipleSectionId + (index + 1) : undefined));
        _formError = _formError.concat(Validators.validateAll(_model[index], rules, _customAttributeName, id));
    });
}

function retrieveName(idx, yourDetails){
    if (_model && _model[idx]) {
        let name = _model[idx].name;
        name.givenName = yourDetails.givenName;
        name.lastName = yourDetails.lastName;
        name.gender = yourDetails.gender;
        name.title = yourDetails.title
        let title = Mapper.getGenderTitle(name.gender,
            name.title,
            _titleList,
            YourDetailsConstants.Values.GENDER_MALE,
            YourDetailsConstants.Values.GENDER_FEMALE);
        name.fullName = Formatter.formatFullname(title, name.givenName, name.lastName);
    }
}

function retrieveAccountSettings(form){
    let accountSettings = form.accountSettings;
    let yourDetails = form.yourDetails;
    if (accountSettings.length > _model.length){
        addInvestors(accountSettings.length - _model.length);
    }
    _.merge(_model, accountSettings);
    
    let list = []
    if (yourDetails.investorList && yourDetails.investorList.length){
        list = list.concat(yourDetails.investorList);
    }
    else if(yourDetails.trusteeList && yourDetails.trusteeList.length){
        list = list.concat(yourDetails.trusteeList);
    }

    if (list.length){
        let idx = 0;
        if (yourDetails.givenName && yourDetails.lastName && yourDetails.title && yourDetails.gender){
            retrieveName(idx++, yourDetails);
        }
        _.forEach(list, function(item){
            retrieveName(idx++, item);
        });
    }
}

class AccountSettingsStoreClass extends EventEmitter {
    constructor() {
        super();
    }

    emitChange() {
        this.emit(CHANGE_EVENT);
    }

    addChangeListener(callback) {
        this.on(CHANGE_EVENT, callback);
    }

    removeChangeListener(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    }

    getModel() {
        return _model;
    }

    getFormError() {
        return _formError;
    }

    getSummaryError() {
        return _summaryError;
    }
}

const AccountSettingsStore = new AccountSettingsStoreClass();

AccountSettingsStore.dispatchToken = AppDispatcher.register((action) => {

    let isAnnuity = Products.isAnnuity(_productId);
    switch (action.actionType){
        case ApplicationActionTypes.APPLICATION_RETRIEVE_SUCCESS:
            setProductId(action.applicationData.productId);
            setAccountType(action.applicationData.form.accountType);
            retrieveAccountSettings(action.applicationData.form);
            break;
        case ApplicationActionTypes.LOAD_TITLE_LIST:
            _titleList = action.titles;
            break;
        case ApplicationActionTypes.NEW_APPLICATION_INITIALISED:
            setProductId(action.productId);
            break;
        case ActionTypes.UPDATE_ACCOUNT_SETTINGS:
            updateAccountSettingsModel(action.fieldId, action.value, action.index);
            validate(action.fieldId, action.componentId, action.value);
            break;
        case AccountTypeActionsTypes.SELECT_ACCOUNT_TYPE:
            setAccountType(action.accountType);
            break;
        case ApplicationActionTypes.VALIDATE_APPLICATION:
            if (isAnnuity){
                validateAll();
            }
            break;
        case YourDetailsActionTypes.UPDATE_YOUR_DETAILS:
            if (isAnnuity){
                updateYourDetailsData(action.fieldId, action.fieldValue, action.index);
            }
            break;
        default:
            return;
    }

    AccountSettingsStore.emitChange();
    return true;
});

storeInit();

export default AccountSettingsStore;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./stores/AccountSettingsStore.js